/* LC Outfit Designer — PDP deep-link sender, Stage 3A */

(function () {
  "use strict";

  if (window.__lcOutfitDesignerPdpLinkInit) {
    return;
  }

  window.__lcOutfitDesignerPdpLinkInit = true;

  const LINK_SELECTOR =
    "[data-lc-outfit-designer-pdp-link]";

  function numericId(value) {
    const normalized =
      String(value || "").trim();

    return /^\d+$/.test(normalized)
      ? normalized
      : "";
  }

  function findVariantInput(link) {
    const formId =
      link.getAttribute(
        "data-lc-ob-product-form-id"
      );

    if (formId) {
      const form =
        document.getElementById(formId);

      if (form) {
        const variantInput =
          form.querySelector(
            'input[name="id"]'
          );

        if (variantInput) {
          return variantInput;
        }
      }
    }

    const productInfo =
      link.closest("product-info");

    if (productInfo) {
      const variantInput =
        productInfo.querySelector(
          'form[action*="/cart/add"] input[name="id"]'
        );

      if (variantInput) {
        return variantInput;
      }
    }

    return null;
  }

  function currentVariantId(link) {
    const variantInput =
      findVariantInput(link);

    const liveVariantId =
      variantInput
        ? numericId(
            variantInput.value
          )
        : "";

    if (liveVariantId) {
      return liveVariantId;
    }

    return numericId(
      link.getAttribute(
        "data-lc-ob-initial-variant-id"
      )
    );
  }

  function buildDesignerUrl(link) {
    const baseUrl =
      link.getAttribute(
        "data-lc-ob-base-url"
      );

    const slot =
      String(
        link.getAttribute(
          "data-lc-ob-slot"
        ) || ""
      ).trim();

    const productId =
      numericId(
        link.getAttribute(
          "data-lc-ob-product-id"
        )
      );

    const variantId =
      currentVariantId(link);

    if (
      !baseUrl ||
      !slot ||
      !productId ||
      !variantId
    ) {
      return null;
    }

    const url =
      new URL(
        baseUrl,
        window.location.origin
      );

    url.searchParams.set(
      "lc_ob_slot",
      slot
    );

    url.searchParams.set(
      "lc_ob_product",
      productId
    );

    url.searchParams.set(
      "lc_ob_variant",
      variantId
    );

    url.searchParams.set(
      "lc_ob_source",
      "pdp"
    );

    return url;
  }

  function syncLink(link) {
    if (!link) {
      return;
    }

    const url =
      buildDesignerUrl(link);

    if (!url) {
      return;
    }

    link.href =
      url.toString();
  }

  function syncLinksWithin(scope) {
    const root =
      scope &&
      typeof scope.querySelectorAll ===
        "function"
        ? scope
        : document;

    root
      .querySelectorAll(
        LINK_SELECTOR
      )
      .forEach(syncLink);
  }

  /*
   * Final synchronization occurs synchronously on click.
   * This guarantees that normal click, Cmd/Ctrl-click, and
   * keyboard activation use the current Shopify form variant.
   */
  document.addEventListener(
    "click",
    function (event) {
      const target =
        event.target;

      if (
        !(target instanceof Element)
      ) {
        return;
      }

      const link =
        target.closest(
          LINK_SELECTOR
        );

      if (!link) {
        return;
      }

      syncLink(link);
    },
    true
  );

  /*
   * Keep the visible href current after ordinary option changes,
   * while still relying on click-time synchronization as the
   * authoritative fallback.
   */
  document.addEventListener(
    "change",
    function (event) {
      const target =
        event.target;

      if (
        !(target instanceof Element)
      ) {
        return;
      }

      const productInfo =
        target.closest(
          "product-info"
        );

      if (!productInfo) {
        return;
      }

      window.requestAnimationFrame(
        function () {
          syncLinksWithin(
            productInfo
          );
        }
      );
    }
  );

  document.addEventListener(
    "focusin",
    function (event) {
      const target =
        event.target;

      if (
        !(target instanceof Element)
      ) {
        return;
      }

      const link =
        target.closest(
          LINK_SELECTOR
        );

      if (link) {
        syncLink(link);
      }
    }
  );

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        syncLinksWithin(document);
      },
      {
        once: true,
      }
    );
  } else {
    syncLinksWithin(document);
  }
})();
